import { useHistory } from "react-router-dom";
import { AsHtml } from "@ww-digital/applanga-js";

import { getEstimatedFinalWeight, getEstimatedWeightLossData } from "../ResultsJoinSequence/WeightLossGraph/utils";
import t from "../../../utils/translate";
import useAppContext from "../../AppContext";
import { DEFAULT_INITIAL_WEIGHT_LB } from "../constants";
import BulletItem from "../../BulletItem";
import Column from "../../Column";
import SiteWrapper from "../../SiteWrapper";
import routes from "../../../routes";
import StickyFooter from "components/StickyFooter";
import WeightLossGraph from "../ResultsJoinSequence/WeightLossGraph";

import styles from "./styles.module.scss";

const getWeightLossData = profile => {
  const initialWeightLb =
    profile?.imperial?.weight || DEFAULT_INITIAL_WEIGHT_LB;
  const weightLossData = getEstimatedWeightLossData(initialWeightLb);
  const estimatedWeightLoss = Math.floor(
    weightLossData[0].weight - Math.floor(weightLossData[9].weight)
  );
  const estimatedFinalWeight = getEstimatedFinalWeight(initialWeightLb);

  return { initialWeightLb, estimatedWeightLoss, estimatedFinalWeight };
};

const ClinicalEligible = (): JSX.Element => {
  const history = useHistory();
  const { profile } = useAppContext();
  const { initialWeightLb, estimatedWeightLoss, estimatedFinalWeight } = getWeightLossData(profile);

  const onContinue = () => {
    history.push(routes.clinicCheckoutTreatmentOptions);
  };

  return (
    <SiteWrapper size="small">
      <Column className={styles.content}>
        <h1 className={styles.heading}>
          {t("CLINICAL_ELIGIBLE_HEADER", {
            name: profile?.firstName || ""
          })}
        </h1>
        <div className={styles.text}>{t("CLINICAL_ELIGIBLE_TEXT")}</div>
        <ul className={styles.bulletList}>
          <BulletItem className={styles.bulletItem}>
            <AsHtml
              value={t("JOIN_SEQUENCE_ELIGIBLE_BULLET_1")}
              tagType="p"
              interpolations={{
                weightLoss: estimatedWeightLoss
              }}
            />
          </BulletItem>
          <BulletItem className={styles.bulletItem}>
          <AsHtml
              value={t("JOIN_SEQUENCE_ELIGIBLE_BULLET_2")}
              tagType="p"
              interpolations={{
                weight: estimatedFinalWeight
              }}
            />
          </BulletItem>
          <BulletItem className={styles.bulletItem}>
            {t("JOIN_SEQUENCE_ELIGIBLE_BULLET_3")}
          </BulletItem>
        </ul>
        <WeightLossGraph initialWeightLb={initialWeightLb} lineColor="#3c34e5" />
        <div className={styles.disclaimer}>
          {t("JOIN_SEQUENCE_ELIGIBLE_DISCLAIMER")}
        </div>
        <StickyFooter
          className={styles.footer}
          nextButtonProps={{
            onNext: onContinue,
            label: t("CLINICAL_ELIGIBLE_CONTINUE")
          }}
        />
      </Column>
    </SiteWrapper>
  );
};

export default ClinicalEligible;
